<template>
  <Renderer ref="renderer" :alpha="true" :antialias="true" resize="true">
    <Camera ref="camera" :position="{ z: 1200, y: 0}" :far="10000" />
    <Scene ref="scene">
      <FbxModel
        ref="model-"
        :src="link3d"
        @load="onReady"
        @progress="onProgress"
        @error="onError"
      />
    </Scene>
  </Renderer>
</template>

<script>
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";

export default {
  name: "Kuhul3DComponent",
  props:{
    link3d:{
      type: String
    },
    id:{
      type: String
    },
  },
  mounted(){
    console.log("link3d", this.link3d)
  },
  methods: {
    onReady(model) {

      const scene = this.$refs.scene.scene;
      const camera = this.$refs.camera.camera;
      const renderer = this.$refs.renderer.renderer;

      // 1️⃣ Centrer le modèle
      const box = new THREE.Box3().setFromObject(model);
      const center = box.getCenter(new THREE.Vector3());
      model.position.sub(center);

      const pivot = new THREE.Group();
      pivot.add(model);
      scene.add(pivot);

      // 2️⃣ HDRI neutre pour reflets naturels
      const pmremGenerator = new THREE.PMREMGenerator(renderer);
      pmremGenerator.compileEquirectangularShader();
      new RGBELoader().load("/hdri/neutral_studio.hdr", (texture) => {
        const envMap = pmremGenerator.fromEquirectangular(texture).texture;
        scene.environment = envMap; // reflets métal
        scene.background = null; // transparent
        texture.dispose();
        pmremGenerator.dispose();
      });

      // 3️⃣ Lumières type studio Blender
      const keyLight = new THREE.DirectionalLight(0xffffff, 1.2);
      keyLight.position.set(500, 300, 500);
      scene.add(keyLight);

      const fillLight = new THREE.DirectionalLight(0xffffff, 0.3);
      fillLight.position.set(-300, 100, 200);
      scene.add(fillLight);

      const rimLight = new THREE.DirectionalLight(0xffffff, 0.8);
      rimLight.position.set(0, 200, -500);
      scene.add(rimLight);

      const ambient = new THREE.AmbientLight(0xffffff, 0.2);
      scene.add(ambient);

      // 4️⃣ Matériau métal réaliste
      model.traverse((child) => {
        if (child.isMesh) {
          // conserve la texture et les couleurs de Blender
          if (child.material.map) child.material.map.encoding = THREE.sRGBEncoding;
          child.material.metalness = 1;
          child.material.roughness = 0.35; // moins miroir, adoucit les reflets
          child.material.envMapIntensity = 1;
        }
      });

      // 5️⃣ Caméra auto-fit
      const size = box.getSize(new THREE.Vector3());
      const maxDim = Math.max(size.x, size.y, size.z);
      const fov = camera.fov * (Math.PI / 180);
      let cameraZ = Math.abs(maxDim / 2 / Math.tan(fov / 2)) * 2; // zoom out plus large
    camera.position.set(center.x, center.y, cameraZ);
    camera.lookAt(center)

      // 6️⃣ Controls
      const controls = new OrbitControls(camera, renderer.domElement);
      controls.target.copy(center);
      controls.enableZoom = false;
      controls.autoRotate = true;
      controls.enableDamping = true;
      controls.dampingFactor = 0.05;

      // 7️⃣ Animation pivot (rotation propre)
      const animate = () => {
        pivot.rotation.y += 0.01; // rotation continue du modèle
        requestAnimationFrame(animate);
        controls.update();
        renderer.render(scene, camera);
      };
      animate();
    },

    onError(e) {
      console.log(e);
    },
  },
};
</script>

<style>
:deep(canvas) {
  width: 100% !important;
  height: 100% !important;
  display: block;
}


.first-3d {
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
}


canvas {
  background: transparent !important;
}
</style>